module.exports = __webpack_public_path__ + "img/reportes.c6878ead.svg";